export default __webpack_public_path__ + "static/media/sierra-flowers.9a27c872.png";